module.exports = __webpack_public_path__ + "img/img2.96767922.png";